// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"a92819c9a6e45ea8b83a","524":"ab4d9a3e1948d790b122","810":"9dd769727ab34cc3a13e"}[chunkId] + ".css";
};